import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/socials/google.svg'
import _imports_1 from '@/assets/images/socials/slack.svg'
import _imports_2 from '@/assets/images/socials/github.svg'
import _imports_3 from '@/assets/images/socials/mailchimp.svg'
import _imports_4 from '@/assets/images/socials/figma.svg'
import _imports_5 from '@/assets/images/socials/facebook.svg'
import _imports_6 from '@/assets/images/socials/twitter.svg'
import _imports_7 from '@/assets/images/socials/instagram.svg'
import _imports_8 from '@/assets/images/socials/dribbble.svg'
import _imports_9 from '@/assets/images/socials/behance.svg'


const _hoisted_1 = { class: "connections-card" }
const _hoisted_2 = { class: "p-0 mb-0 mt-0 list-unstyled" }
const _hoisted_3 = { class: "d-flex align-items-center justify-space-between" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "icon" }
const _hoisted_6 = { class: "d-flex align-items-center justify-space-between" }
const _hoisted_7 = { class: "d-flex align-items-center" }
const _hoisted_8 = { class: "icon" }
const _hoisted_9 = { class: "d-flex align-items-center justify-space-between" }
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = { class: "icon" }
const _hoisted_12 = { class: "d-flex align-items-center justify-space-between" }
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = { class: "icon" }
const _hoisted_15 = { class: "d-flex align-items-center justify-space-between" }
const _hoisted_16 = { class: "d-flex align-items-center" }
const _hoisted_17 = { class: "icon" }
const _hoisted_18 = { class: "p-0 mb-0 mt-0 list-unstyled" }
const _hoisted_19 = { class: "d-flex align-items-center justify-space-between" }
const _hoisted_20 = { class: "d-flex align-items-center" }
const _hoisted_21 = { class: "icon" }
const _hoisted_22 = { class: "d-flex align-items-center justify-space-between" }
const _hoisted_23 = { class: "d-flex align-items-center" }
const _hoisted_24 = { class: "icon" }
const _hoisted_25 = { class: "d-flex align-items-center justify-space-between" }
const _hoisted_26 = { class: "d-flex align-items-center" }
const _hoisted_27 = { class: "icon" }
const _hoisted_28 = { class: "d-flex align-items-center justify-space-between" }
const _hoisted_29 = { class: "d-flex align-items-center" }
const _hoisted_30 = { class: "icon" }
const _hoisted_31 = { class: "d-flex align-items-center justify-space-between" }
const _hoisted_32 = { class: "d-flex align-items-center" }
const _hoisted_33 = { class: "icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[20] || (_cache[20] = _createElementVNode("h5", null, "Connected Accounts", -1)),
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_v_img, {
              src: _imports_0,
              alt: "google"
            })
          ]),
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "title" }, [
            _createElementVNode("span", { class: "fw-semibold text-black d-block" }, " Google "),
            _createElementVNode("span", { class: "d-block" }, " Calendar and Contacts ")
          ], -1))
        ]),
        _cache[1] || (_cache[1] = _createElementVNode("button", null, "Click to Disconnect", -1))
      ]),
      _createElementVNode("li", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_v_img, {
              src: _imports_1,
              alt: "slack"
            })
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "title" }, [
            _createElementVNode("span", { class: "fw-semibold text-black d-block" }, " Slack "),
            _createElementVNode("span", { class: "d-block" }, " Communications ")
          ], -1))
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("button", null, "Click to Disconnect", -1))
      ]),
      _createElementVNode("li", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_v_img, {
              src: _imports_2,
              alt: "github"
            })
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "title" }, [
            _createElementVNode("span", { class: "fw-semibold text-black d-block" }, " GitHub "),
            _createElementVNode("span", { class: "d-block" }, " Manage your Git repositories ")
          ], -1))
        ]),
        _cache[5] || (_cache[5] = _createElementVNode("button", null, "Click to Disconnect", -1))
      ]),
      _createElementVNode("li", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_v_img, {
              src: _imports_3,
              alt: "mailchimp"
            })
          ]),
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "title" }, [
            _createElementVNode("span", { class: "fw-semibold text-black d-block" }, " Mailchimp "),
            _createElementVNode("span", { class: "d-block" }, " Email marketing service ")
          ], -1))
        ]),
        _cache[7] || (_cache[7] = _createElementVNode("button", null, "Click to Disconnect", -1))
      ]),
      _createElementVNode("li", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_v_img, {
              src: _imports_4,
              alt: "figma"
            })
          ]),
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "title" }, [
            _createElementVNode("span", { class: "fw-semibold text-black d-block" }, " Figma "),
            _createElementVNode("span", { class: "d-block" }, " Design ")
          ], -1))
        ]),
        _cache[9] || (_cache[9] = _createElementVNode("button", null, "Click to Disconnect", -1))
      ])
    ]),
    _createVNode(_component_v_divider),
    _cache[21] || (_cache[21] = _createElementVNode("h5", null, "Social Accounts", -1)),
    _createElementVNode("ul", _hoisted_18, [
      _createElementVNode("li", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_v_img, {
              src: _imports_5,
              alt: "facebook"
            })
          ]),
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "title" }, [
            _createElementVNode("span", { class: "fw-semibold text-black d-block" }, " Facebook ")
          ], -1))
        ]),
        _cache[11] || (_cache[11] = _createElementVNode("button", null, "Click to Disconnect", -1))
      ]),
      _createElementVNode("li", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_v_img, {
              src: _imports_6,
              alt: "twitter"
            })
          ]),
          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "title" }, [
            _createElementVNode("span", { class: "fw-semibold text-black d-block" }, " X ")
          ], -1))
        ]),
        _cache[13] || (_cache[13] = _createElementVNode("button", null, "Click to Disconnect", -1))
      ]),
      _createElementVNode("li", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_component_v_img, {
              src: _imports_7,
              alt: "instagram"
            })
          ]),
          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "title" }, [
            _createElementVNode("span", { class: "fw-semibold text-black d-block" }, " Instagram ")
          ], -1))
        ]),
        _cache[15] || (_cache[15] = _createElementVNode("button", { class: "text-body pointer-none" }, "Not Connected", -1))
      ]),
      _createElementVNode("li", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createVNode(_component_v_img, {
              src: _imports_8,
              alt: "dribbble"
            })
          ]),
          _cache[16] || (_cache[16] = _createElementVNode("div", { class: "title" }, [
            _createElementVNode("span", { class: "fw-semibold text-black d-block" }, " Dribbble ")
          ], -1))
        ]),
        _cache[17] || (_cache[17] = _createElementVNode("button", null, "Click to Disconnect", -1))
      ]),
      _createElementVNode("li", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createVNode(_component_v_img, {
              src: _imports_9,
              alt: "behance"
            })
          ]),
          _cache[18] || (_cache[18] = _createElementVNode("div", { class: "title" }, [
            _createElementVNode("span", { class: "fw-semibold text-black d-block" }, " Behance ")
          ], -1))
        ]),
        _cache[19] || (_cache[19] = _createElementVNode("button", null, "Click to Disconnect", -1))
      ])
    ])
  ]))
}